import { colors } from "../../../styles/theme";

/**
 * Einheitliches Erscheinungsbild für aufklappbare Unterspalten (z.B. Monate unter
 * einem Betriebsjahr im Zins-/Tilgungsplan, oder Kennzahlen unter einem Score in
 * der Windpark-Übersicht). Leicht getönter Hintergrund + kleinere Schrift heben
 * die Unterspalten optisch von den Hauptspalten ab.
 */
export const collapsibleSubColumnSx = {
  header: {
    backgroundColor: colors.background.tableHeaderAlt,
    fontSize: "0.75rem",
    whiteSpace: "nowrap",
  },
  cell: {
    backgroundColor: colors.background.tableHeaderAlt,
    fontSize: "0.8rem",
    // Zahlen mit Einheit ("27,4 %", "26.000.000 €") dürfen nie umbrechen – die Tabelle
    // läuft mit tableLayout: "fixed", eine zu schmale Spalte bräche sonst hinter dem Wert um.
    whiteSpace: "nowrap",
  },
} as const;
